import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    StartTime: {
      validations: []
    }, 
    EndTime: {
      validations: []
    },
    PlannedGuestCount: {
      validations: []
    },  
    SiteName: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name: *',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name: *',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number: *',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email: *',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time:',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00'},
              { label: '10:30AM', value: '10:30:00'},
              { label: '11:00AM', value: '11:00:00'},
              { label: '11:30AM', value: '11:30:00'},
              { label: '12:00PM', value: '12:00:00'},
              { label: '12:30PM', value: '12:30:00'},
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00'}
            ],
            mapping: 'StartTime'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time:',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00'},
              { label: '10:30AM', value: '10:30:00'},
              { label: '11:00AM', value: '11:00:00'},
              { label: '11:30AM', value: '11:30:00'},
              { label: '12:00PM', value: '12:00:00'},
              { label: '12:30PM', value: '12:30:00'},
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00'}
            ],
            mapping: 'EndTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated # of Guests:',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Site Name:',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Details:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'City of Florence Contact Form',
    formId: '407',
    clientKey: '115BDFD8-FF65-471C-AEC8-50B1DCEC6AEB',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/cityofflorence/form_structure.js